// RecruitmentRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import RecruitmentLayout from "../Pages/RecruitmentLayout";
import Dashboard from "../../Dashboard/Pages/Dashboard";
import AddLead from "../../Leads/Pages/AddLead";
import EditLead  from "../../Leads/Pages/EditLead";
import MyLeads from "../../Leads/Pages/MyLeads";
import EditBasicDetails from "../../Leads/Pages/EditBasicDetails";
import LeadTransferRequests from "../../Leads/Pages/LeadTransferRequests ";
import LeadTransferProcessedRequests from "../../Leads/Pages/LeadTransferProcessedRequests";
import MyLeadTransferRequests from "../../Leads/Pages/MyLeadTransferRequests";
import TeamLeads from "../../Leads/Pages/TeamLeads";
import TeamTransferRequests from "../../Leads/Pages/TeamTransferRequests.";
import ResolvedTeamTransferRequests from "../../Leads/Pages/ResolvedTeamTransferRequests";
import CallLog from "../../Report/Pages/CallLog";

const RecruitmentRoutes = () => {
  return (
    <Routes>
      <Route element={<RecruitmentLayout />}>
        <Route path="/dashboard" element={ <Dashboard />}/>
        <Route path="/Add-Lead" element={<AddLead /> } />
        <Route path="/Edit-Lead/:leadUID" element={<EditLead />} />
        <Route path="/my-leads" element={<MyLeads />} />
        <Route path="/edit-basic-details/:leadUID" element={<EditBasicDetails />} />
        <Route path="/lead-transfer-requests" element={<LeadTransferRequests />} />
        <Route path="/lead-transfer-resolved" element={<LeadTransferProcessedRequests />} />
        <Route path="/my-lead-transfer-requests" element={<MyLeadTransferRequests />} />
        <Route path="/team-leads" element={<TeamLeads />} />
        <Route path="/team-transfer-request" element={<TeamTransferRequests />} />
        <Route path="/team-transfer-resolved" element={<ResolvedTeamTransferRequests />} />
        <Route path="/call-logs" element={<CallLog />} />
      </Route>
    </Routes>
  );
};

export default RecruitmentRoutes;
